<template>
  <div v-if="documents.length" class="profile-tile">
    <div>
      <h4 class="" style="font-weight: 500; margin-bottom: 0;">Documents</h4>
      <hr>
    </div>

    <div class="row">
      <div v-for="document in documents" :key="document.id" class="col-lg-4">
        <div class="center py-4 px-3 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <div v-if="!document.template">
            <h5 class="mb-3">{{ document.title }}<span v-if="document.title == 'Medical Release'"> - {{ document.field1 }}</span><span v-if="document.status == 'Signed'"><i style="font-size: 11px; margin-left: 5px; color: #444;" class="material-icons mt-1">check_circle</i></span></h5>
            <button v-if="document.title == 'Transportation Consent' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showTransportationConsentModal(document)">Sign</button>
            <button v-if="document.title == 'Transportation Consent' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showTransportationConsentModal(document)">View</button>
            <button v-if="document.title == 'Use of Client Vehicle' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showUseofClientVehicleModal(document)">Sign</button>
            <button v-if="document.title == 'Use of Client Vehicle' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showUseofClientVehicleModal(document)">View</button>
            <button v-if="document.title == 'Transport with Employee Vehicle' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showTransportChildrenEmployeeVehicleModal(document)">Sign</button>
            <button v-if="document.title == 'Transport with Employee Vehicle' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showTransportChildrenEmployeeVehicleModal(document)">View</button>
            <button v-if="document.title == 'Medical Release' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showMedicalReleaseModal(document)">Sign</button>
            <button v-if="document.title == 'Medical Release' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showMedicalReleaseModal(document)">View</button>

            <button v-if="document.title == 'Client Agency Agreement' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showFamilyAgencyContractModal(document)">Sign</button>
            <button v-if="document.title == 'Client Agency Agreement' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showFamilyAgencyContractModal(document)">View</button>
          </div>

          <div v-if="document.template">
            <!-- {{ document }} -->
            <h5 class="mb-3">{{ document.title }}<span v-if="document.deactivated"> (Inactive)</span><span v-if="document.status == 'Signed' || document.status == 'Saved'"><i style="font-size: 11px; margin-left: 5px; color: #444;" class="material-icons mt-1">check_circle</i></span></h5>
            <button v-if="document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showDocumentModal(document)">Sign</button>
            <!-- <button v-if="document.status == 'Unsigned' && $store.getters.isAgent === true" class="mylisting-button dark-button mt-2" @click="showEditDocumentModal(document)">Edit</button> -->
            <button v-if="document.status == 'Signed' || document.status == 'Saved' || document.deactivated" class="mylisting-button dark-button" @click="showDocumentModal(document)">View</button>
            <!-- <button v-if="$store.getters.isAgent === true" class="mylisting-button danger-button" @click="deleteDocument(document)">Delete</button> -->
          </div>

          <!-- <button class="mylisting-button danger-button" @click="deleteDocument(document)">Delete</button> -->
          <!-- <button class="mylisting-button danger-button" @click="unsignDocument(document)">Unsign</button> -->
        </div>
      </div>
    </div>

    <modal name="transportation-consent-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <transportation-consent :user="user" :document="document" @documentSigned="documentSigned()"></transportation-consent>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('transportation-consent-modal')">Close</button>
      </div>
    </modal>

    <modal name="useof-client-vehicle-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <useof-client-vehicle :user="user" :document="document" @documentSigned="documentSigned()"></useof-client-vehicle>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('useof-client-vehicle-modal')">Close</button>
      </div>
    </modal>

    <modal name="transport-children-employee-vehicle-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <transport-children-employee-vehicle :user="user" :document="document" @documentSigned="documentSigned()"></transport-children-employee-vehicle>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('transport-children-employee-vehicle-modal')">Close</button>
      </div>
    </modal>

    <modal name="medical-release-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <medical-release :user="user" :document="document" @documentSigned="documentSigned()"></medical-release>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('medical-release-modal')">Close</button>
      </div>
    </modal>

    <modal name="family-agency-contract-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <family-agency-contract :user="user" :document="document" @documentSigned="documentSigned()"></family-agency-contract>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('family-agency-contract-modal')">Close</button>
      </div>
    </modal>

    <modal name="document-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <document :user="user" :document="document" @documentSigned="documentSigned()" @documentSaved="documentSaved()"></document>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('document-modal')">Close</button>
        <!-- <button class="mylisting-button secondary-button float-right" v-if="document.signing_name" @click="downloadPDF()">Download PDF</button> -->
      </div>
    </modal>

    <modal name="document-signed-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Your document has been signed.</h2>
        <h5>We will be in touch shortly!</h5>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('document-signed-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="delete-document-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <div class="">
          <h3>Are you sure you want to delete the document {{ document.title }}?</h3>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-document-modal')" style="">Close</button>
        <button class="mylisting-button danger-button" style="float: right;" @click="deleteDocument(document)">Delete Document</button>
      </div>
    </modal>

  </div>
</template>

<script>
import axios from 'axios'

import TransportationConsent from './TransportationConsent'
import UseofClientVehicle from './UseofClientVehicle'
import TransportChildrenEmployeeVehicle from './TransportChildrenEmployeeVehicle'
import MedicalRelease from './MedicalRelease'

import FamilyAgencyContract from './FamilyAgencyContract'

import Document from '../../candidates/profile/Document'

export default {
  props: ['user'],
  components: {
    TransportationConsent,
    UseofClientVehicle,
    TransportChildrenEmployeeVehicle,
    MedicalRelease,

    FamilyAgencyContract,

    Document,
  },
  data() {
    return {
      documents: [],
      document: {},
    }
  },
  created() {
    this.getDocuments()
  },
  methods: {
    getDocuments() {
      axios.get(`/api/documents/?signing_user=${this.user.id}`)
        .then(res => {
          console.log(res)
          this.documents = res.data
          this.documents = this.documents.sort((a, b) => (a.id > b.id) ? 1 : -1)
        })
    },
    showTransportationConsentModal(document) {
      this.document = document
      this.$modal.show('transportation-consent-modal')
    },
    showUseofClientVehicleModal(document) {
      this.document = document
      this.$modal.show('useof-client-vehicle-modal')
    },
    showTransportChildrenEmployeeVehicleModal(document) {
      this.document = document
      this.$modal.show('transport-children-employee-vehicle-modal')
    },
    showMedicalReleaseModal(document) {
      this.document = document
      this.$modal.show('medical-release-modal')
    },
    showFamilyAgencyContractModal(document) {
      this.document = document
      this.$modal.show('family-agency-contract-modal')
    },
    showDocumentModal(document) {
      this.document = document
      this.$modal.show('document-modal')
    },
    documentSigned() {
      this.getDocuments()
      this.$modal.hide('transportation-consent-modal')
      this.$modal.hide('useof-client-vehicle-modal')
      this.$modal.hide('transport-children-employee-vehicle-modal')
      this.$modal.hide('medical-release-modal')

      this.$modal.hide('family-agency-contract-modal')
      this.$modal.hide('document-modal')
      this.$modal.show('document-signed-modal')

      this.$store.dispatch('sendEmails',
        {
          subject: `Document Signed - ${this.user.first_name} ${this.user.last_name} | ${this.document.title}`,
          message: 'Hello,' + '\n\n' +
          `The client ${this.user.first_name} ${this.user.last_name} just signed the following document: ${this.document.title}\n\n`+
          'Cheers!',
          from: this.$store.getters.agencyFromEmail,
          // emails: [this.$store.getters.enginehireAdminEmail, agencyEmail],
          // emails: [this.$store.getters.enginehireAdminEmail],
          emails: [this.$store.getters.enginehireLoggingEmail, this.user.selector9],
          reply: this.$store.getters.agencyReplyEmail,
          // userID: this.aakashid,
          userID: 4,
        }
      )
    },

    deleteDocument(document) {
      axios.delete(`/api/documents/${document.id}/`)
        .then(res => {
          this.getDocuments()
        })
        .catch(error => console.log(error))
    },
    unsignDocument(document) {
      axios.patch(`/api/documents/${document.id}/`, {
        status: 'Unsigned',
        signing_name: '',
      })
        .then(res => {
          this.getDocuments()
        })
        .catch(error => console.log(error))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employers/documents/Documents.vue